export default "__VITE_ASSET__6eaeb1ba__"